import {cashBoxRegister} from "../../../hoc/cashBoxRegister";

const CashBoxCashOutRegister = cashBoxRegister("CashBoxCashOutRegister")

export default CashBoxCashOutRegister
